import React from "react"
import {useTranslation} from "react-i18next"
import {twMerge} from "tailwind-merge"

import {ASalesCycleSalesFlows} from "../../services/types.generated.ts"
import {enumTranslKey} from "../../utils/i18n.tsx"

const SALES_FLOW_STYLES: Record<ASalesCycleSalesFlows, string> = {
  [ASalesCycleSalesFlows.NewBiz]: "border-cr-blue bg-cr-blue-light text-cr-blue",
  [ASalesCycleSalesFlows.Upsell]: "border-cr-cyan bg-cr-cyan-light text-cr-cyan-dark",
  [ASalesCycleSalesFlows.CrossSell]: "border-cr-blue-dark bg-cr-blue-light text-cr-blue-dark",
}

export const SalesFlowBadge: React.FC<{salesFlow: ASalesCycleSalesFlows; className?: string}> = ({
  salesFlow,
  className,
}) => {
  const {t} = useTranslation()

  return (
    <span
      className={twMerge(
        "inline-flex items-center gap-2 rounded-full border px-3.5 py-1 text-xs font-bold whitespace-nowrap",
        SALES_FLOW_STYLES[salesFlow],
        className
      )}
    >
      <span className={"size-2 rounded-full bg-current"} />
      {t(enumTranslKey("ASalesCycleSalesFlows", salesFlow))}
    </span>
  )
}
